





































import Component, { mixins } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { CreditCardAssignment } from "@scrile/api-provider/dist/api/CreditCardAssignmentsProvider";
import { RecurringBillingSchedule } from "@scrile/api-provider/dist/api/RecurringBillingScheduleProvider";
import { Subscription } from "@scrile/api-provider/dist/api/SubscriptionProvider";
import { checkRole } from "@scrile/tools/dist/lib/SecurityHelpers";
import WithAuthUser from "@/mixins/WithAuthUser";
import { ROLES } from "@/const";
import BaseButton from "@/components/BaseButton";
import BasePage from "@/components/BasePage";
import EmptyContent from "@/components/EmptyContent";
import InfiniteScroll from "@/components/InfiniteScroll";
import PageTitle from "@/components/PageTitle";
import CancelConfirm from "../CancelConfirm";
import SubscriptionItemView from "../SubscriptionItem";

@Component({
  name: "PageManageRecurringView",
  components: { CancelConfirm, InfiniteScroll, BasePage, PageTitle, EmptyContent, BaseButton },
})
export default class PageManageRecurringView extends mixins(WithAuthUser) {
  @Prop({ type: Boolean, required: true })
  public readonly loading!: boolean;

  @Prop({ type: Boolean, required: true })
  public readonly canceling!: boolean;

  @Prop({ type: Boolean, required: true })
  public readonly enableScroll!: boolean;

  @Prop({ required: true })
  public readonly creditCard!: CreditCardAssignment | null;

  @Prop({ type: Array, required: true })
  public readonly list!: Subscription[];

  public subscriptionItemView = SubscriptionItemView;

  public cancelRecurring: RecurringBillingSchedule | null = null;

  public cancelTitle: string = "";

  public cancelDescription: string = "";

  public cancelCb: Function = () => {};

  public get cancelShowConfirm(): boolean {
    return !!this.cancelRecurring;
  }

  get isCreator() {
    return checkRole(this.authUser?.role || "", ROLES.CREATOR);
  }

  public onCancel(
    {
      recurring,
      title,
      description,
    }: {
      recurring: RecurringBillingSchedule;
      title: string;
      description: string;
    },
    cb: Function
  ) {
    this.cancelRecurring = recurring;
    this.cancelDescription = description;
    this.cancelTitle = title;
    this.cancelCb = () => {
      cb();
      this.cancelRecurring = null;
      this.cancelDescription = "";
      this.cancelTitle = "";
      this.cancelCb = () => {};
    };
  }

  public onConfirmInput(status: boolean) {
    if (status) {
      this.$emit("cancel", this.cancelRecurring, () => this.cancelCb());
    } else this.cancelCb();
  }
}
